import type {
  CampaignGroup,
  ChartType,
  SendInsightDimension,
  SendInsightTab,
} from "./types";

export const BUILDER_PARAM = "builder";

export interface BuilderState {
  name: string;
  chartType: ChartType;
  presetKey: string;
  segmentBy: SendInsightDimension;
  segmentBy2: SendInsightDimension;
  windowDays: number;
  filterChannelTypes: string[];
  filterCampaignGroups: CampaignGroup[];
}

const SHARED_DEFAULTS: Omit<BuilderState, "presetKey" | "segmentBy"> = {
  name: "",
  chartType: "line",
  segmentBy2: "none",
  windowDays: 7,
  filterChannelTypes: [],
  filterCampaignGroups: [],
};

const TAB_DEFAULTS: Record<
  SendInsightTab,
  Pick<BuilderState, "presetKey" | "segmentBy">
> = {
  comparison: { presetKey: "send_count", segmentBy: "experiment" },
  fidelity: { presetKey: "match_rate", segmentBy: "none" },
};

export function getDefaultBuilderState(tab: SendInsightTab): BuilderState {
  return { ...SHARED_DEFAULTS, ...TAB_DEFAULTS[tab] };
}

export function parseBuilderParams(
  search: URLSearchParams,
): BuilderState | null {
  const raw = search.get(BUILDER_PARAM);
  if (!raw) return null;
  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch {
    return null;
  }
}

export function serializeBuilderParam(
  tab: SendInsightTab,
  state?: Partial<BuilderState>,
): string {
  const merged = { ...getDefaultBuilderState(tab), ...state };
  return encodeURIComponent(JSON.stringify(merged));
}
